import request from "./client";

export type RoomRecord = {
  id: number;
  property_id: number;
  room_number: string;
  floor_number?: number | null;
  room_status: string;
  notes?: string | null;
  created_at?: string;
};

export async function getRooms() {
  return request<RoomRecord[]>("/api/rooms");
}

export async function createRoom(payload: Record<string, unknown>) {
  return request<RoomRecord>("/api/rooms", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateRoom(id: number, payload: Record<string, unknown>) {
  return request<RoomRecord>(`/api/rooms/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteRoom(id: number) {
  return request<{ success: boolean }>(`/api/rooms/${id}`, {
    method: "DELETE",
  });
}
